import { render, staticRenderFns } from "./ContactsEditor.vue?vue&type=template&id=17cce1cd&"
import script from "./ContactsEditor.vue?vue&type=script&lang=ts&"
export * from "./ContactsEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports